import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localeHu from '@angular/common/locales/hu';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import {
    LogLevel,
    provideBreadCrumbConfig,
    provideCookieConfig,
    provideIntroductionConfig,
    provideLanguageConfig,
    provideLoadingOverlay,
    provideNavigationConfig,
    provideSharedConfig,
    provideTranslationConfig
} from '@prekog/common-ui';
import { AppConfigService } from './core/config/app-config.service';
import { routes } from './app.routes';

registerLocaleData(localeHu, 'hu-HU', localeHuExtra);

export function createAppConfig(): ApplicationConfig {
    const configService = new AppConfigService();
    const config = configService.config;
    const consentExpiredTime = new Date(Date.now() + config.consentExpiredDays * 24 * 60 * 60 * 1000);

    return {
        providers: [
            provideZoneChangeDetection({ eventCoalescing: true }),
            { provide: MAT_DIALOG_DATA, useValue: {} },
            {
                provide: LOCALE_ID,
                useValue: 'hu-HU'
            },
            {
                provide: MAT_RADIO_DEFAULT_OPTIONS,
                useValue: { color: 'black' }
            },
            { provide: 'CONFIGURATOR_BASE_URL', useValue: config.backendConfiguratorUrl },
            { provide: 'API_URL', useValue: config.apiUrl },
            { provide: 'DOWNLOAD_FILE_URL', useValue: config.downloadUrl },
            { provide: 'PRODUCTION', useValue: config.production },
            { provide: 'REGENERO_BASE_URL', useValue: config.regeneroBaseUrl },
            provideHttpClient(withInterceptorsFromDi()),
            provideLoadingOverlay(),
            provideSharedConfig({
                logLevel: config.logLevel,
                enableUseCaseStatusLogs: config.enableUseCaseStatusLogs
            }),
            provideTranslationConfig({ translatedLanguages: ['hu'] }),
            provideLanguageConfig({}),
            provideBreadCrumbConfig({}),
            provideIntroductionConfig({}),
            provideCookieConfig({ consentExpiredTime: consentExpiredTime }),
            provideNavigationConfig({}),
            provideRouter(
                routes,
                withComponentInputBinding(),
                withInMemoryScrolling({
                    scrollPositionRestoration: 'top',
                    anchorScrolling: 'enabled'
                })
            )
        ]
    };
}
